function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon_contact_adress_bor");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5173\\u4E8E\\u6211\\u4EEC",
  transform: "translate(-1340.000000, -4685.000000)"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-2.000000, 4403.000000)"
}, React.createElement("g", {
  id: "Repeat-Group",
  transform: "translate(377.000000, 242.000000)"
}, React.createElement("g", {
  id: "template/card/contact",
  transform: "translate(810.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  transform: "translate(63.000000, 40.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(92.500000, 0.000000)"
}, React.createElement("g", {
  id: "icon/contact/phone"
}, React.createElement("g", {
  id: "icon/contact/adress"
}, React.createElement("g", {
  id: "icon/contact/adress_bor"
}, React.createElement("path", {
  d: "M20.1767709,9.81318629 C21.5997022,9.27278322 22.941248,9 24.2009303,9 C30.3860057,9 35.4,14.0087181 35.4,20.1872851 C35.4,22.487091 34.6904679,24.7310203 33.3680107,26.6135545 L25.3766555,37.9892524 C24.9209817,38.6379043 24.025195,38.7947326 23.3758599,38.3395383 C23.2395289,38.2439681 23.1208759,38.12544 23.025205,37.9892524 L15.0207044,26.594842 C11.4892324,21.5677902 12.7059324,14.6327484 17.7382798,11.1049927 C18.4943139,10.5750007 19.3134396,10.1410636 20.1767709,9.81318629 Z M20.6871973,11.154359 C19.9352636,11.4399296 19.2218315,11.8178748 18.5633502,12.2794807 C14.1803379,15.3520422 13.1206315,21.3922399 16.1964297,25.7706398 L23.9071011,36.7467843 C24.0210999,36.9090617 24.245066,36.9481992 24.4073434,36.8342004 C24.4413165,36.8103344 24.4708935,36.7807575 24.4947594,36.7467843 L32.1922838,25.7893547 L32.1922838,25.7893547 C33.3451291,24.1482651 33.9636605,22.1921297 33.9636605,20.1872851 C33.9636605,14.8011518 29.5927373,10.434828 24.2009303,10.434828 C23.1258753,10.434828 21.9547903,10.6729506 20.6871973,11.154359 Z",
  id: "Rectangle",
  fill: "currentColor",
  fillRule: "nonzero"
}), React.createElement("circle", {
  id: "Oval",
  stroke: "currentColor",
  strokeWidth: 1.43633945,
  fillRule: "nonzero",
  cx: 24.2,
  cy: 21.4,
  r: 4.4
}), React.createElement("g", {
  id: "empty"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 48,
  height: 48
})))))))))))));

var SvgContactIconAdress = function SvgContactIconAdress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "49px",
    height: "48px",
    viewBox: "0 0 49 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContactIconAdress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_icon_adress.08e3143b.svg";
export { ForwardRef as ReactComponent };